"use client";

import { useEffect, useState } from "react";
import { ACTIVE_RELEASE_ROOT_MARGIN } from "../_logic/constants";

/**
 * Tracks which release section is being read, for the month rail.
 *
 * @param months - Release months (`YYYY-MM`), each the id of a section on the page, newest first.
 * @returns The month whose section sits in the reading band near the top of the viewport.
 */
export function useActiveRelease(months: string[]): string {
  // States
  const [active, setActive] = useState(months[0] ?? "");

  // Effects
  useEffect(() => {
    const sections = months.map((month) => document.getElementById(month)).filter((el) => el !== null);
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (visible.length === 0) return;
        setActive(visible[0].target.id);
      },
      { rootMargin: ACTIVE_RELEASE_ROOT_MARGIN }
    );
    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, [months]);

  return active;
}
